import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=29bacd1e"
import script from "./BasePage.vue?vue&type=script&lang=js"
export * from "./BasePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports